module.exports = __webpack_public_path__ + "static/img/PSD63-S.f41b41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/params/mini/PSD63-S.png
// module id = mpIM
// module chunks = 1